import { Box, styled } from "@mui/material";

type StyledMessagePoppupProps = {
    backgroundColor: string;
} 

export const StyledMessagePoppupList = styled(Box)(({theme}) => ({
    position: "absolute",
    width: "30rem",
    right: "0",
    top: "0",
    boxSizing: "border-box",
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
}))

export const StyledMessagePoppup = styled(Box)<StyledMessagePoppupProps>(({ theme, backgroundColor }) => ({
    width: "100%",
    height: "3rem",
    borderRadius: "5px",
    opacity: "1",
    color: theme.color.background,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingInline: "2rem",
    boxSizing: "border-box",
    gap: "1rem",
    svg: {
        color: theme.color?.background,
    }
}))